/*
  at least one number,
  at least one upper and one lower case letters,
  at least one special symbols,
  no spaces,
  only latin letters
  min symbols - 8
  max symbols - 128
 */
export const PASSWORD_REGEX =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,128}$/;
/*
  Pattern forbids spaces and specific special characters: <, >, ;, ', ", /, [, ], {, }.
  It allows inputting any characters except these forbidden ones.
*/
export const FORBIDDEN_CHARS_AND_SPACES_REGEXP = /^[^<>';"/[\]{} ]*$/;
export const FORBIDDEN_CHARS_REGEXP = /^[^<>;{}]*$/;
export const REPLACE_ZIP_PAC_EXTENSION = /(:G^|.zip|.pak)/g;
export const TIMESTAMPS_ALLOWED =
  /^([0-5]?\d:[0-5]?\d(?:\.\d+)?)(\s*;\s*[0-5]?\d:[0-5]?\d(?:\.\d+)?)*$/;
export const AP_PM_TIME_FORMAT = /^(0[1-9]|1[0-2]):([0-5][0-9]) (AM|PM)$/i;
